const DEFAULT_SEO = {
  title: '宠物星系｜宠物纪念服务与数字档案平台',
  description: '宠物星系为宠物主提供宠物纪念、生命故事记录与数字档案服务，让珍贵回忆被好好保存。',
  keywords: '宠物纪念,宠物数字档案,宠物生命故事,宠物纪念服务,宠物星系'
}

function upsertMeta(attribute, key, content) {
  let element = document.head.querySelector(`meta[${attribute}="${key}"]`)
  if (!element) {
    element = document.createElement('meta')
    element.setAttribute(attribute, key)
    document.head.appendChild(element)
  }
  element.setAttribute('content', content)
}

function upsertCanonical(url) {
  let element = document.head.querySelector('link[rel="canonical"]')
  if (!element) {
    element = document.createElement('link')
    element.setAttribute('rel', 'canonical')
    document.head.appendChild(element)
  }
  element.setAttribute('href', url)
}

export function updateSeo(route) {
  const seo = { ...DEFAULT_SEO, ...(route.meta && route.meta.seo) }
  const pageUrl = new URL(route.path, 'https://www.cwxx.pet/').toString()

  document.title = seo.title
  upsertMeta('name', 'description', seo.description)
  upsertMeta('name', 'keywords', seo.keywords)
  upsertMeta('name', 'robots', 'index,follow')
  upsertMeta('property', 'og:title', seo.title)
  upsertMeta('property', 'og:description', seo.description)
  upsertMeta('property', 'og:type', 'website')
  upsertMeta('property', 'og:url', pageUrl)
  upsertMeta('name', 'twitter:card', 'summary')
  upsertMeta('name', 'twitter:title', seo.title)
  upsertMeta('name', 'twitter:description', seo.description)
  upsertCanonical(pageUrl)

  let structuredData = document.head.querySelector('script[data-seo="website"]')
  if (!structuredData) {
    structuredData = document.createElement('script')
    structuredData.type = 'application/ld+json'
    structuredData.dataset.seo = 'website'
    document.head.appendChild(structuredData)
  }
  structuredData.textContent = JSON.stringify({
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '宠物星系',
    description: seo.description,
    url: pageUrl,
    inLanguage: 'zh-CN'
  })
}

export { DEFAULT_SEO }
